module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-497d777a4150b37f5d9a4e6c7fa308d7.jpg";